<template>
  <div class="form-group" style="text-align: center;">
    <div class="input-group color-picker" ref="colorpicker">
      <input type="text" class="form-control" v-model="colorValue" @focus="showPicker()" @input="updateFromInput" />
      <span class="input-group-addon color-picker-container">
        <span class="current-color" :style="'background-color: ' + colorValue" @click="togglePicker()"></span>
        <color-picker :value="colors" @input="updateFromPicker" v-if="displayPicker" />
      </span>
    </div>
  </div>
</template>

<script>
  import {
    Chrome
  } from "vue-color";
  export default {
    name: "Colorpicker",
    props: {
      value: String,
    },
    components: {
      "color-picker": Chrome,
    },
    mounted() {
      this.updateFromInput(this.value);
    },
    data() {
      return {
        colors: {
          hex: "#000000",
        },
        colorValue: "",
        displayPicker: false,
      };
    },
    methods: {
      setColor(color) {
        this.updateColors(color);
        this.colorValue = color.hex;
      },
      updateColors(color) {
        if (color.slice(0, 1) == "#") {
          this.colors = {
            hex: color,
          };
          this.colorValue = color;
        } else if (color.slice(0, 4) == "rgba") {
          var rgba = color.replace(/^rgba?\(|\s+|\)$/g, "").split(","),
            hex =
            "#" +
            (
              (1 << 24) +
              (parseInt(rgba[0]) << 16) +
              (parseInt(rgba[1]) << 8) +
              parseInt(rgba[2])
            )
            .toString(16)
            .slice(1);
          this.colors = {
            hex: hex,
            a: rgba[3],
          };
        }
      },
      showPicker() {
        document.addEventListener("click", this.documentClick);
        this.displayPicker = true;
      },
      hidePicker() {
        document.removeEventListener("click", this.documentClick);
        this.displayPicker = false;
      },
      togglePicker() {
        this.displayPicker ? this.hidePicker() : this.showPicker();
      },
      updateFromInput() {
        this.updateColors(this.value);
        this.$emit('input', this.value)
      },
      updateFromPicker(color) {
        this.colors = color;
        if (color.rgba.a == 1) {
          this.colorValue = color.hex;
          this.$emit('input', this.colorValue)
        } else {
          this.colorValue =
            "rgba(" +
            color.rgba.r +
            ", " +
            color.rgba.g +
            ", " +
            color.rgba.b +
            ", " +
            color.rgba.a +
            ")";
          this.$emit('input', this.colorValue)
        }
      },
      documentClick(e) {
        var el = this.$refs.colorpicker,
          target = e.target;
        if (el !== target && !el.contains(target)) {
          this.hidePicker();
        }
      },
    },
    computed: {},
  };
</script>